export const Language = {
    ENGLISH: 'English',
    SPANISH: 'Spanish',
    FRENCH: 'French',
    CHINESE: 'Chinese',
};

export const LANGUAGES = [Language.ENGLISH, Language.SPANISH, Language.FRENCH, Language.CHINESE];

export const SPEEDS = [0.75, 1, 1.25, 1.5, 1.75, 2];

export const SettingsPanelItems = {
    MAIN: 'Main',
    SPEED: 'Speed',
    LANGUAGES: 'Languages',
    AUDIO: 'Audio',
};

export type SettingsPanelType = (typeof SettingsPanelItems)[keyof typeof SettingsPanelItems];
